import React, { useState } from "react";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper
} from "@mui/material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from "@mui/material";
import { useEffect } from "react";
import axios from "axios";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import LanguageIcon from "@mui/icons-material/Language";
import EditSite from "./EditSite";
import "./ViewSite.css";
import { toast, ToastContainer } from "react-toastify";
// import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";



const API_URL = process.env.REACT_APP_API_DJANGO_URL;
const ViewAdminSite = () => {
  const [rows, setRows] = useState([]);
  const [selectedSite, setSelectedSite] = useState(null);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [siteToDelete, setSiteToDelete] = useState(null);
  const [deleteMessage, setDeleteMessage] = useState("");
  const [deleteError, setDeleteError] = useState(false);


// Add these inside your ViewSites component
const [page, setPage] = useState(0);
const [rowsPerPage, setRowsPerPage] = useState(5);

const handleChangePage = (event, newPage) => {
  setPage(newPage);
};

const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setPage(0);
};



useEffect(() => {
  const customerId = localStorage.getItem("customer_id");
  console.log(customerId)

  if (customerId) {
    fetchSites();
  }
}, []);

const fetchSites = async () => {
  try {
    const token = localStorage.getItem("accessToken");
    const customerId = localStorage.getItem("customer_id");

    if (!customerId) return;

    // Force GET with empty JSON body
    const response = await axios({
      url: `${API_URL}/api/get_customer_sites_admin/${customerId}/`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
         "X-User-Type": "A",   // ✅ ADD THIS
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: {}, // 👈 add empty object to make Content-Type valid
    });

    const formattedData = response.data.data.map((site, index) => ({
      id: index + 1,
      site_id: site.site_id,
      name: site.name,
      survey_no: site.survey_no,
      pin_code: site.pin_code,
      society_reg_no: site.society_reg_no,
      address: site.address,
      latitude: site.latitude,
      longitude: site.longitude,
      asset_id: site.asset_id,
    }));

    setRows(formattedData);
  } catch (error) {
    console.error("Error fetching sites:", error);
  }
};


  const handleEditClick = (site) => {
    setSelectedSite(site);
    setEditOpen(true);
  };

  const handleCloseEdit = () => setEditOpen(false);

  const handleSaveEdit = (updatedSite) => {
    setRows(rows.map(r => r.id === updatedSite.id ? updatedSite : r));
    setEditOpen(false);
  };


  const handleDeleteClick = (site) => {
    setSiteToDelete(site);
    setDeleteOpen(true);
  };


  const handleCancelDelete = () => {
  setDeleteOpen(false);
  setDeleteMessage("");
  setDeleteError(false);
};

 const handleConfirmDelete = async () => {
  if (!siteToDelete) return;

  try {
    const token = localStorage.getItem("accessToken");
    const assetId = siteToDelete.asset_id;

    const response = await axios({
      url: `${API_URL}/api/delete_site/${assetId}/`,
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: {},
    });

    // ✅ Success
    const msg = response.data.message || "Site deleted successfully!";
    setDeleteMessage(msg);
    setDeleteError(false);

    toast.success(msg);

    // Remove row after short delay (optional UX)
    setTimeout(() => {
      setRows(rows.filter(r => r.id !== siteToDelete.id));
      setDeleteOpen(false);
      setDeleteMessage("");
    }, 1500);

  } catch (error) {
    console.error("Error deleting site:", error);

    const backendMessage =
      error.response?.data?.error ||
      error.response?.data?.message ||
      "Failed to delete site.";

    // ❌ Show inside modal
    setDeleteMessage(backendMessage);
    setDeleteError(true);

    // toast.error(backendMessage);
  }
};

  // const handleCancelDelete = () => {
  //   setDeleteOpen(false);
  // };

  return (
    <Box className="view-sites-container">

     {/* ✅ Toast Container */}
    <ToastContainer position="top-right" autoClose={3000} />

    <TableContainer component={Paper} className="site-table"></TableContainer>
      <TableContainer component={Paper} className="site-table">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Sr No</TableCell>
              <TableCell>Site Name</TableCell>
              <TableCell>Survey No</TableCell>
              <TableCell>Pin Code</TableCell>
              <TableCell>Society Reg No</TableCell>
              <TableCell>Address</TableCell>
              {/* <TableCell align="center">Actions</TableCell> */}
            </TableRow>
          </TableHead>

          <TableBody>
            {rows
  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
  .map((row, index) => (
    <TableRow key={row.id}>
      <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                <TableCell>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    
                    {row.name}
                  </Box>
                </TableCell>
                <TableCell>{row.survey_no}</TableCell>
                <TableCell>{row.pin_code}</TableCell>
                <TableCell>{row.society_reg_no}</TableCell>
                <TableCell>{row.address}</TableCell>
                <TableCell align="center">
                  {/* <IconButton color="primary" onClick={() => handleEditClick(row)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton color="error" onClick={() => handleDeleteClick(row)}>
                    <DeleteIcon />
                  </IconButton> */}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>


       <div className="pagination-bar">
  <div className="rows-select">
    Rows per page:
    <select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
      <option value={5}>5</option>
      <option value={10}>10</option>
      <option value={25}>25</option>
    </select>
  </div>
  <div className="page-info">
    {rows.length > 0 ? page * rowsPerPage + 1 : 0}-
    {Math.min((page + 1) * rowsPerPage, rows.length)} of {rows.length}
  </div>
  <div className="page-arrows">
    <button disabled={page === 0} onClick={() => setPage(page - 1)}>‹</button>
    <button disabled={(page + 1) * rowsPerPage >= rows.length} onClick={() => setPage(page + 1)}>›</button>
  </div>
</div>
      </TableContainer>

      {selectedSite && (
        <EditSite
          open={editOpen}
          onClose={handleCloseEdit}
          site={selectedSite}
          onSave={handleSaveEdit}
        />
      )}

     <Dialog
  open={deleteOpen}
  onClose={handleCancelDelete}
  className="delete-dialog"
>
  <DialogTitle className="delete-dialog-title">
    Delete Site
  </DialogTitle>

  <DialogContent>
    <DialogContentText className="delete-dialog-text">
      {!deleteMessage &&
        "Are you sure to delete this site?"}
    </DialogContentText>

    {/* ✅ Backend Message */}
    {deleteMessage && (
      <Box
        sx={{
          mt: 2,
          p: 2,
          borderRadius: 2,
          backgroundColor: deleteError ? "#fdecea" : "#e8f5e9",
          color: deleteError ? "#d32f2f" : "#2e7d32",
          fontWeight: 500,
        }}
      >
        {deleteMessage}
      </Box>
    )}
  </DialogContent>

 <DialogActions className="delete-dialog-actions">

  {/* ❌ If error → show only OK */}
  {deleteError && deleteMessage ? (
    <Button
      onClick={handleCancelDelete}
      variant="contained"
      color="primary"
    >
      OK
    </Button>
  ) : deleteMessage && !deleteError ? (
    /* ✅ If success → show Done */
    <Button
      onClick={handleCancelDelete}
      variant="contained"
      color="success"
    >
      Done
    </Button>
  ) : (
    /* 🟢 Default → show Cancel + Delete */
    <>
      <Button
        onClick={handleCancelDelete}
        variant="outlined"
        className="delete-cancel-btn"
      >
        Cancel
      </Button>

      <Button
        onClick={handleConfirmDelete}
        variant="contained"
        color="error"
      >
        Delete
      </Button>
    </>
  )}

</DialogActions>
</Dialog>
    </Box>
  );
};

export default ViewAdminSite;